import styled from "styled-components";


export const Contenedor = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: left;
    max-width: 20em;
`

export const CuadroColor = styled.div `
    width: 1.1em;
    height: 1.1em;
    margin: 4px 0.5em  auto 1em;

`